document.addEventListener("DOMContentLoaded", function () {
  // Elementos del DOM
  const cara2Box = document.getElementById("seleccion-cara2");
  const designSelect = document.getElementById("diseno-cara2-select");
  const form = document.querySelector('form[action*="/cart/add"]');
  const notification = document.getElementById("custom-cart-notification");

  // Función para vista previa
  function updatePreview() {
    if (!designSelect) return; // Seguridad si el elemento no existe
    const selectedOption = designSelect.options[designSelect.selectedIndex];
    if (selectedOption.value) {
      const previewImage = document.getElementById("design-preview-image");
      const previewName = document.getElementById("design-preview-name");
      const previewContainer = document.getElementById("selected-design-preview");
      
      if (previewImage) previewImage.src = selectedOption.dataset.image;
      if (previewName) previewName.textContent = selectedOption.text;
      if (previewContainer) previewContainer.style.display = "block";
    } else {
      const previewContainer = document.getElementById("selected-design-preview");
      if (previewContainer) previewContainer.style.display = "none";
    }
  }

  // Función para mostrar/ocultar selector de cara 2
  function updateCara2Visibility() {
    // Si no hay inputs de Caras, salimos para no causar errores
    const radios = document.querySelectorAll('input[type="radio"][name^="Caras"]');
    if (radios.length === 0) return;

    let selectedValue = Array.from(radios).find((radio) => radio.checked)?.value || "";
    const isTwoFaces = selectedValue.includes("2");

    if (cara2Box) {
        if (isTwoFaces) {
          cara2Box.style.display = "block";
          if (designSelect) designSelect.required = true;
        } else {
          cara2Box.style.display = "none";
          if (designSelect) {
              designSelect.required = false;
              designSelect.selectedIndex = 0;
              designSelect.style.border = "";
          }
          updatePreview();
        }
    }
  }

  // Función para mostrar notificación (CORREGIDA PARA NO ROMPERSE)
  function showNotification(message, isError = false) {
    if (notification) {
        notification.textContent = message;
        notification.style.backgroundColor = isError ? "#d30000" : "#000";
        notification.style.display = "block";
        notification.style.animation = "fadeIn 0.3s ease";

        setTimeout(() => {
          notification.style.animation = "fadeOut 0.3s ease";
          setTimeout(() => (notification.style.display = "none"), 300);
        }, 3000);
    } else {
        // Fallback si no existe el elemento HTML de notificación
        console.log("Notificación:", message);
        if (isError) alert(message); 
    }
  }

  // Función principal para agregar al carrito
  async function handleAddToCart(e) {
    // 1. VERIFICACIÓN CRÍTICA:
    // Si NO es la opción de 2 caras, NO interrumpimos el tema.
    // Dejamos que el tema Trade haga su trabajo (abrir el Drawer Cart).
    const radios = document.querySelectorAll('input[type="radio"][name^="Caras"]');
    const isTwoFaces = Array.from(radios).find((radio) => radio.checked)?.value === "2";

    if (!isTwoFaces) {
        return; // Salimos de la función y permitimos el comportamiento nativo
    }

    // Si LLEGAMOS AQUÍ, es porque SI es un producto de 2 caras y debemos intervenir
    e.preventDefault();
    e.stopImmediatePropagation();

    // Validación para cara 2
    if (designSelect && designSelect.selectedIndex === 0) {
      designSelect.style.border = "2px solid red";
      if(cara2Box) cara2Box.scrollIntoView({ behavior: "smooth", block: "center" });
      showNotification("Debes seleccionar un diseño para la segunda cara", true);
      return false;
    }

    const button = e.target.closest('[name="add"], [type="submit"], [name="checkout"]');
    const originalText = button ? button.innerHTML : "Agregar";
    if (button) {
        button.innerHTML = "Procesando...";
        button.disabled = true;
    }

    try {
      const form = e.target.closest("form");
      const formData = new FormData(form);

      if (designSelect && designSelect.value) {
        const selectedOption = designSelect.options[designSelect.selectedIndex];
        const imageUrl = selectedOption.dataset.imageUrl;
        const productName = selectedOption.textContent.trim();

        formData.append("properties[Nombre_diseno_segunda_cara]", productName);
        
        if (imageUrl) {
            const fullImageUrl = imageUrl.startsWith("//") ? "https:" + imageUrl : imageUrl;
            formData.append("properties[Imagen_cara_2]", fullImageUrl);
        }
      }

      // Fetch al carrito
      const response = await fetch("/cart/add", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Error al agregar al carrito");

      // ÉXITO
      showNotification("Producto agregado al carrito");
      
      // OPCIÓN: Redirigir al carrito para asegurar que se vea la personalización compleja
      setTimeout(() => {
        window.location.href = "/cart";
      }, 500);

    } catch (error) {
      console.error("Error:", error);
      showNotification(error.message || "Error al agregar", true);
      if (button) {
          button.innerHTML = originalText;
          button.disabled = false;
      }
    }
  }

  // Configurar event listeners
  function setupEventListeners() {
    document
      .querySelectorAll('input[type="radio"][name^="Caras"]')
      .forEach((radio) => {
        radio.addEventListener("change", updateCara2Visibility);
      });

    if (form) {
      form.addEventListener("change", () => {
        setTimeout(updateCara2Visibility, 50);
      });
    }

    if (designSelect) {
      designSelect.addEventListener("change", updatePreview);
    }

    // Botones de añadir
    document
      .querySelectorAll('[name="add"], [type="submit"], [name="checkout"]')
      .forEach((btn) => {
        // Usamos capture: true para interceptar antes, pero ahora validamos adentro
        btn.addEventListener("click", handleAddToCart, { capture: true });
      });
  }

  setupEventListeners();
  updateCara2Visibility();
});

// Estilos para animaciones (se mantienen igual)
const style = document.createElement("style");
style.textContent = `
  @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } }
`;
document.head.appendChild(style);